import { httpClient } from 'utils/http/httpClient';

import { publicationConnector } from './publication';

export const publicationApi = publicationConnector(httpClient);
